import { CategoryRounded } from '@mui/icons-material';
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setGroupSelectedItem } from 'app/actions/geofence';
import { Autosizer, Scrollbar } from 'app/components';
import { groupSelectedItemSelector, sortItemsSelector } from 'app/selectors/geofence';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';

const GeofenceGroupList = function () {
  const dispatch = useDispatch();
  const groupSelectedItem = useSelector(groupSelectedItemSelector);
  const sortItems = useSelector(sortItemsSelector);

  const handleItemClick = (value) => dispatch(setGroupSelectedItem(value));

  return (
    <Box
      component='div'
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        padding: theme.spacing(0),
        '.simplebar-offset > div': {
          '&::-webkit-scrollbar': {
            width: 0,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
            boxShadow: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
          '.MuiListItem-root': {
            width: '100%',
            userSelect: 'none',
            padding: theme.spacing(0),
            marginBottom: '2px',
            borderRadius: '0',
            '.MuiListItemAvatar-root': {
              minWidth: '36px',
            },
            '.MuiAvatar-circular': {
              width: '24px',
              height: '24px',
              color: theme.palette.primary.main,
              bgcolor: alpha(theme.palette.primary.main, 0.12),
              svg: {
                fontSize: '16px',
              },
            },
            '.MuiListItemButton-root': {
              padding: theme.spacing(1, 2),
              borderRadius: '0',
            },
            '.MuiListItemText-root': {
              margin: theme.spacing(0),
            },
          },
        },
      })}>
      <Autosizer>
        {({ height, width }) => (
          <Box sx={{ height, width }}>
            <Scrollbar>
              {({ scrollableNodeRef, contentNodeRef }) => {
                return (
                  <FixedSizeList
                    height={height}
                    itemSize={36}
                    itemCount={sortItems.length}
                    innerRef={contentNodeRef}
                    outerRef={scrollableNodeRef}
                    innerElementType={geofenceGroupInnerElementType}
                    itemData={{
                      items: sortItems,
                      selectedItem: groupSelectedItem,
                      onClick: handleItemClick,
                    }}>
                    {GeofenceGroupListItem}
                  </FixedSizeList>
                );
              }}
            </Scrollbar>
          </Box>
        )}
      </Autosizer>
    </Box>
  );
};

const geofenceGroupInnerElementType = forwardRef((props, ref) => <List ref={ref} disablePadding {...props} />);

const GeofenceGroupListItem = ({ data, index, style }) => {
  const { items, selectedItem, onClick } = data;

  return (
    <ListItem key={index} style={style} selected={items[index].id === selectedItem?.id} onClick={() => onClick(items[index])}>
      <ListItemButton>
        <ListItemAvatar>
          <Avatar>
            <CategoryRounded fontSize='small' />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={items[index].name} />
      </ListItemButton>
    </ListItem>
  );
};

export default GeofenceGroupList;
